﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IExcelTableField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.ExcelTableField, eOutputFieldType.excelTable)
export class ExcelTableField extends OutputField implements IExcelTableField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public deleted: boolean;
    public sheetName: string;
    public coord: string;
}
